define([
	'internal_util/UiUtil',
	'view/AuthenticationOptionView',
	'view/ConnectionView',
	
	'amdi18n-loader?!state/nls/IdentityManagementState_strings',
	
	'lib/jquery'
], function (
	UiUtil,
	AuthenticationOptionView,
	ConnectionView,
	
	Strings,
	
	jQuery
) {
	'use strict';

	/**
	 * ActivationView class
	 */
	return function () {
		var _authenticationOptionView = new AuthenticationOptionView(),
			_connectionView  = new ConnectionView(),
			_view;

		_view = (function () {
			var $view = jQuery("<div style='flex-wrap: wrap;' id='skIdS_activation-container'></div>");

			$view.append(_authenticationOptionView.get())
				.append(_connectionView.get());
		
			$view.append("<div id='skIdS_activation_FIDO-container'>" +
					"<p>"+Strings.activate_fido+"</p><div id='skIdS_identity-fido_container' style='text-align: center;'>" +
						"<video autoplay muted loop poster='" +UiUtil.getImage('FIDO_ANI_PNG').url()+ "' style='width: 250px;'>" +
							"<source src='" +UiUtil.getImage('FIDO_ANI_MP4').url()+ "' type='video/mp4' />" +
						"</video></div>");

			return $view;
		})();
		
		_view.find('#skIdS_activation_FIDO-container').hide();


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function (authenticationOption, fido) {
			_authenticationOptionView.update(authenticationOption, false, fido);
			if (fido) {
				_view.find('#skIdS_activation_FIDO-container').show();
			} else {
				_view.find('#skIdS_activation_FIDO-container').hide();
			}
		};

		this.enableAnimation = function () {
			_connectionView.enableAnimation();
		};

		this.disableAnimation = function () {
			_connectionView.disableAnimation();
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/ActivationView.js
// module id = 153
// module chunks = 1